import { FC, PropsWithChildren} from "react";

const CenterLayout: FC<PropsWithChildren> = ({ children }) => (
  <div className="h-full">
    <main>
      <div className="flex min-h-[100vh] bg-gray-100 flex-col justify-center py-12 sm:px-6 lg:px-8">   
        {children}
      </div>
    </main>
</div>
);

export default CenterLayout;
